import { Injectable } from '@angular/core';
import {
  CanActivate, Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot
} from '@angular/router';
import { AuthService } from '../models/auth.service';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.authService.isLoggedIn()) { return true; }

    // Store the attempted URL for redirecting 
    this.authService.redirectUrl = state.url;
    //this.authService.redirectMsg = "Session is expired. Please login again.";

    // Navigate to the login page
    this.router.navigate(['/Unauthenticated']);
    return false;
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/guard/auth-guard.service.ts